export const yesNo = (input) => {
    if (input === 'true' || input === true) {
        return 'بله';
    } else if (input === 'false' || input === false) {
        return 'خیر';
    } else {
        return input;
    }
}